import { Divider, Theme, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import {
  SeverityByCategory,
  SeverityChangeFactorTypes,
} from '../../types/issues-types';
import SeverityTrendIcon from '../SeverityTrendIcon';
import { FaDoorOpen } from 'react-icons/fa';
import { GiMeteorImpact } from 'react-icons/gi';
import { ImTarget } from 'react-icons/im';
import React from 'react';

const SeverityChangeFactor: FC<IssueCardSeverityProps> = ({
  severitiesByType,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.mappingSeverity}>
      {Object.entries(severitiesByType).map((severityChange, index) => {
        return (
          <React.Fragment key={index}>
            <Divider orientation='vertical' flexItem />
            <div className={classes.elementBg}>
              <Typography
                variant='body1'
                color='text.secondary'
                fontWeight='bold'
                className={classes.title}>
                {severityChange[0] ===
                SeverityChangeFactorTypes.Reachability ? (
                  <FaDoorOpen className={classes.icon} />
                ) : severityChange[0] ===
                  SeverityChangeFactorTypes.Exploitability ? (
                  <ImTarget className={classes.icon} />
                ) : (
                  <GiMeteorImpact className={classes.icon} />
                )}
                {severityChange &&
                  severityChange.length > 0 &&
                  severityChange[0]}
              </Typography>
              {severityChange &&
                severityChange.length > 0 &&
                severityChange[1].map(item => (
                  <div key={item.name}>
                    <Tooltip title={item.description} placement='left' arrow>
                      <Typography
                        variant='body1'
                        color='text.primary'
                        className={classes.nameContainer}>
                        <SeverityTrendIcon trend={item.trend} />
                        {item.name}
                      </Typography>
                    </Tooltip>
                  </div>
                ))}
            </div>
          </React.Fragment>
        );
      })}
      <Divider orientation='vertical' flexItem />
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  title: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'left',
    alignItems: 'center',
    marginBlockEnd: theme.spacing(0.5),
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  trendIcon: {
    width: 15,
  },
  mappingSeverity: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
  },
  elementBg: {
    width: 240,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    paddingBlock: theme.spacing(1),
    gap: theme.spacing(0.5),
  },
  icon: {
    color: theme.palette.primary.main,
  },
}));

export interface IssueCardSeverityProps {
  severitiesByType: SeverityByCategory;
}

export default SeverityChangeFactor;
